module.exports = __webpack_public_path__ + "media/images/bg/shapes/career/grass-85c4b6d6cdee433a8befa1c5e1c50bac.svg";